module.exports = __webpack_public_path__ + "img/1956_no.bef15f22.svg";